const TAG_SEPARATOR_PATTERN = /[\n,;]+/g;

export function normalizeTypeTag(rawTag: string): string | null {
  const stripped = rawTag
    .trim()
    .replace(/^#+/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^[-_]+|[-_]+$/g, "")
    .toLocaleLowerCase("ru-RU");

  if (!stripped) {
    return null;
  }

  return stripped.slice(0, 40);
}

export function normalizeTypeTags(
  rawTags: readonly string[] | null | undefined,
): string[] {
  if (!rawTags || rawTags.length === 0) {
    return [];
  }

  const seen = new Set<string>();
  const result: string[] = [];

  rawTags.forEach((rawTag) => {
    const normalized = normalizeTypeTag(String(rawTag));
    if (!normalized || seen.has(normalized)) {
      return;
    }

    seen.add(normalized);
    result.push(normalized);
  });

  return result;
}

export function parseTypeTagsInput(value: string): string[] {
  if (!value.trim()) {
    return [];
  }

  const parts = value
    .replace(TAG_SEPARATOR_PATTERN, " ")
    .split(/\s+/g)
    .filter(Boolean);

  return normalizeTypeTags(parts);
}

export function formatTypeTag(tag: string): string {
  return `#${tag}`;
}

export function resolveEntityTypeTags(input: {
  typeTags?: readonly string[] | null;
  fallbackTypeName?: string | null;
}): string[] {
  const normalized = normalizeTypeTags(input.typeTags);
  if (normalized.length > 0) {
    return normalized;
  }

  const fallbackSource = input.fallbackTypeName?.trim()
    ? input.fallbackTypeName.trim()
    : "";
  const fallbackTag = normalizeTypeTag(fallbackSource);

  return fallbackTag ? [fallbackTag] : [];
}
